import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { ChannelOption } from './Types'
import {
  CreateCampaignPayload,
  createCampaignRequest,
  GenerateCampaignDocsPayload,
  generateDocsRequest,
} from 'components/CampaignCreationModal/createRequest'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { AiCampaignCreationError } from 'components/CampaignCreationModal/CampaignCreationModal'
import { useMutation, useQueryClient } from 'react-query'

export const useGenerateCampaign = () => {
  return useMutation(async (payload: CreateCampaignPayload) => {
    const response = await createCampaignRequest(payload)
    if (response.type !== SUCCESS_RESPONSE_TYPE) {
      throw new AiCampaignCreationError(
        'There was a problem generating the campaign',
        { errorCode: 'campaign' },
        {
          responseData: response.data,
          request: payload,
        },
      )
    }
    return response.data
  })
}

export const useGenerateDocs = (docTypes?: Array<ChannelOption>) => {
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  return useMutation(
    async (payload: GenerateCampaignDocsPayload) => {
      const response = await generateDocsRequest(payload)
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new AiCampaignCreationError(
          `There was a problem generating the campaign docs: ${response.data}`,
          { errorCode: 'campaign' },
          {
            responseData: response.data,
            request: {
              workspaceId,
              createCampaignResponseDataContentCampaignId: payload.campaign_id,
              selectedChannelTypes: docTypes ? Array.from(docTypes) : payload.channels,
            },
          },
        )
      }
      return response.data
    },
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['schedules', variables.campaign_id, 'detail', 'sources'])
      },
    },
  )
}
